import { render } from "./hardware_x_body_main.vue?vue&type=template&id=64c6427e"
import script from "./hardware_x_body_main.vue?vue&type=script&lang=js"
export * from "./hardware_x_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__